import React, { useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from "react-redux";
import * as actions from '../../../reducers/formTable';
import { formChangeAsObj, formInitialize } from '../../../reducers/form';
import { fetchDispath } from '../../../functions/fetch'
import { Button, Tab, Tabs, Grid, IconButton, Typography, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import PageList from '../../../components/PageListAPI'
import GridProps from '../../../components/GridProps'
import moment from 'moment'
import { makeStyles } from '@mui/styles';
import { getFile } from '../../../api/list'
import GetAppIcon from '@mui/icons-material/GetApp';
import { getMOPById, printMOPById, updMOPStatusById } from "../../../api/doc";
import print from '../../../functions/print'
import DialogChangeStatus from './source/DialogStatus'
import { enqueueSnackbar } from '../../../reducers/notifier'
import { statusAll } from './source/type.enum'
import ByIdAddFile from './source/ByIdAddFile'
import VisibilityIcon from '@mui/icons-material/Visibility';
import DialogFile from '../orderOutfitPlan/source/DialogFile'
import AllPrice from '../shipmentMaterial/add/source/AllPrice'
import { nds } from '../../../enum/nds.enum'
import { Link } from 'react-router-dom';
import { useCan } from 'src/hooks/useCan';
import { SLUGS } from 'src/enum/permissions.enum';

const tableM = 'OutfitOPByIdM'
const tableF = 'OutfitOPByIdF'
const formShipment = 'MOP_Shipment'
const formCopy = 'MOP_Copy'
const column = [
  { id: 'name', name: 'Наименование' },
  { id: 'providerName', name: 'Наименование поставщика' },
  { id: 'count', align: 'right', name: 'Количество' },
  { id: 'storageUnit', align: 'center', name: 'Ед.изм' },
  { id: 'balance', align: 'right', name: 'По смете' },
  { id: 'price', align: 'right', name: 'Цена за ед.' },
  { id: 'summ', align: 'right', name: 'Сумма' },
  { id: 'nds', align: 'center', name: 'НДС' },
  { id: 'summNDS', align: 'right', name: 'Сумма с НДС' },
  { id: 'dateOrder', align: 'right', name: 'Дата доставки' },
]
export default function OrderProviderById({ match, history, location }) {
  const can = useCan()
  const [value, setValue] = useState(0)
  const [byId, setById] = useState({
    date: '',
    dateOrder: '',
    provider: '',
    idProvider: 0,
    title: ''
  })
  const [statusDoc, setStatusDoc] = useState(statusAll[0] || { value: null, label: '' })
  const [openDialog, changeOpenDialog] = useState(false)
  const [fileName, setFileName] = useState('')
  const [summ, setSumm] = useState(0)
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(formInitialize({ arr: [], provider: { value: null, label: null } }, { name: formShipment }))
    dispatch(actions.initFormTable({ name: tableF }))
    dispatch(actions.initFormTable({ name: tableM }))
    return () => {
      dispatch(actions.clearFormTable(tableM))
      dispatch(actions.clearFormTable(tableF))
    }
  }, [dispatch])
  useEffect(() => {
    dispatch(fetchDispath({
      param: {
        idProject: match.params.idProject,
        id: match.params.idDoc
      },
      progress: true,
      request: getMOPById,
    }))
      .then((res) => {
        if (!res) return;
        let summ = 0
        const arr = res.get.table.map(e => {
          const obj = {
            ...e,
            name: [e.name, e.typeMark, e.vendorCode].join('; '),
            price: e.price || 0,
            count: e.count || 0,
            dateOrder: e.dateOrder ? moment(e.dateOrder).format('DD.MM.YYYY') : '',
            nds: nds.find(l => l.value === e.nds)?.label || 'Без НДС',
            summ: Math.round((e.count || 0) * (e.price || 0) * 100) / 100,
            summNDS: Math.round((e.count || 0) * (e.price || 0) * 100 * ((e.nds === 'NDS20') ? 1.2 : 1)) / 100,
          }
          summ += obj.summNDS
          return obj
        })
        setById({
          date: moment(res.get.header.date).format('LL'),
          dateOrder: res.get.header.dateOrder,
          title: res.get.header.title,
          provider: res.get.header.provider,
          idProvider: res.get.header.idProvider,
        })
        setSumm(summ)
        const status = statusAll.find(e => e.value === res.get.header.status)
        if (status) setStatusDoc(status)
        dispatch(actions.loadFormTable({ get: res.get.files }, { name: tableF, id: 'id' }))
        dispatch(actions.loadFormTable({ count: res.count, get: arr, }, { name: getMOPById, id: 'id' }))
      })
  }, [dispatch, match.params.idProject, match.params.idDoc, setById])
  const handleClick = (obj) => {
    dispatch(fetchDispath({
      param: {
        id: obj.name,
      },
      progress: false,
      request: getFile,
      buff: true
    }))
      .then(res => {
        if (!res) return;
        res.blob().then(blob => {
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.href = url;
          a.download = obj.name;
          document.body.appendChild(a);
          a.click();
          setTimeout(function () {
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
          }, 0);
        })
      })
  }
  const fetch = useCallback((obj) => { return dispatch(fetchDispath(obj)) }, [dispatch])
  const handlePrint = () => {
    print(
      fetch,
      {
        param: {
          id: match.params.idDoc,
        },
        request: printMOPById,
      }
    )
  }
  const changeStatus = (status) => {
    fetch({
      param: {
        id: match.params.idDoc,
      },
      body: {
        status: status.value,
      },
      progress: true,
      request: updMOPStatusById,
    })
      .then((res) => {
        if (res.success) {
          dispatch(enqueueSnackbar({
            message: `Успешно`,
            options: { variant: 'success' }
          }))
          setStatusDoc(status)
          changeOpenDialog(false)
        }
      })
  }
  const formTable = useSelector(state => state.formTable[tableM] || state.formTable.default)
  const handleClickToShipment = () => {
    const arrMaterial = formTable.allIds;
    const arrObj = {}
    const arr = arrMaterial.map(key => {
      const { idMaterial, count, price = 0, nds = 'none', idEstimate, providerName } = formTable.byId[key]
      console.log(formTable.byId[key])
      if (arrObj[idMaterial]) arrObj[idMaterial] += 1; else arrObj[idMaterial] = 1
      return { id: idMaterial, count: count, price, nds, idEstimate: idEstimate, estimateName: providerName }
    })
    dispatch(formChangeAsObj({ arr, provider: { value: byId.idProvider.toString(), label: byId.provider }, dateOrder: moment(byId.dateOrder).format('YYYY-MM-DD') }, { name: formShipment }))
    const path = `/projects/${match.params.idProject}/shipment/materials/add`
    history.push(path);
  }
  const handleCopy = () => {
    const arrMaterial = formTable.allIds;
    const arrObj = {}
    const arr = arrMaterial.map(key => {
      const { idMaterial, count } = formTable.byId[key]
      if (arrObj[idMaterial]) arrObj[idMaterial] += 1; else arrObj[idMaterial] = 1
      return { id: idMaterial, count: count }
    })
    dispatch(formInitialize({ arr: arr }, { name: formCopy }))
    const path = `/projects/${match.params.idProject}/order/provider/add`
    history.push(path);
  }
  const toLinkEdit = React.forwardRef((props, ref) => (
    <Link ref={ref} to={`${location.pathname}/edit`} {...props} />
  ));
  const columnsFile = [
    { id: 'type', name: 'Тип' },
    { id: 'originalName', name: 'Название' },
    { id: 'fileView', name: '', type: 'component', width: '5%', component: ({ obj }) => <IconButton onClick={() => setFileName(obj.name)} size="small"><VisibilityIcon /></IconButton> },
    { id: 'file', name: '', align: 'right', type: 'component', width: '5%', component: ({ obj }) => <IconButton onClick={() => handleClick(obj)} size="small"><GetAppIcon /></IconButton> },
  ]
  return (
    <div className='App-paper'>
      <DialogFile fileName={fileName} />
      <Button color='primary' onClick={handlePrint} >Печать </Button>
      {can(SLUGS.DOC.MAT_ORDER_P.MANAGE)&&<React.Fragment>
        <Button color='primary' onClick={() => handleClickToShipment()} >Создать док. покупки </Button>
        <Button color='primary' onClick={handleCopy} >Создать копию </Button>
        <Button component={toLinkEdit} color="primary" >Изменить</Button>
      </React.Fragment>}
      <DialogChangeStatus open={openDialog} onClose={() => changeOpenDialog(false)} selectedNow={statusDoc} changeStatus={changeStatus} />
      <Grid
        item
        container
        xs={6}
      >
        <GridProps name='Описание' value={byId.title} />
        <GridProps name='Дата создания' value={byId.date} />
        <GridProps name='Желаемая дата отгрузки' value={moment(byId.dateOrder).format('LL')} />
        <GridProps name='Поставщик' value={byId.provider} />
        <Grid item xs={6}><Typography>Статус</Typography></Grid>
        <Grid
          item
          container
          xs={6}
          spacing={2}
        >
          <Grid item><Typography>{statusDoc.label}</Typography></Grid>
          <Grid item>
            <Tooltip title="Изменить статус">
              <IconButton style={{ fontSize: '0.875rem' }} color='primary' size='small' onClick={() => changeOpenDialog(true)}>
                <EditIcon fontSize="inherit" />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      </Grid>
      <Tabs value={value} onChange={(e, v) => setValue(v)} indicatorColor='primary'>
        <Tab label='Материалы' />
        <Tab label='Файлы' />
      </Tabs>
      {value === 0 && <>
        <PageListCustom
          name={getMOPById}
          headerLink={undefined}
          columns={column}
          match={match}
          history={history}
          location={location}
        />
        <AllPrice summ={summ || 0} />
      </>
      }
      {value === 1 &&
        <PageListCustom
          name={tableF}
          headerLink={can(SLUGS.DOC.MAT_ORDER_P.MANAGE)?<ByIdAddFile idDoc={match.params.idDoc} formName={tableF} />: undefined}
          columns={columnsFile}
          match={match}
          history={history}
          location={location}
        />
      }
      <Button color='primary' onClick={() => history.goBack()}>Назад</Button>
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  container: {
    height: '100%'
  },
}));
function PageListCustom({ name, columns, match, history, location, headerLink }) {
  const classes = useStyles()
  return <PageList
    classes={classes}
    name={name}
    headerLink={headerLink}
    columns={columns}
    idName='id'
    csv={false}
    click={false}
    notLoad={true}
    notClear={true}
    match={match}
    history={history}
    location={location}
    pagination={false}
    goBack={false}
    tableProps={{ pagination: false }}
  />
}